import { differenceInSeconds, intervalToDuration } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';

const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    years: '00',
    months: '00',
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  });
  const [endTime, setEndTime] = useState(null);

  const updateCountdown = useCallback(() => {
    if (!endTime) return;

    try {
      const now = new Date();
      const then = new Date(endTime);

      if (Number.isNaN(then.getTime())) {
        throw new Error('Invalid date');
      }

      const diffTime = differenceInSeconds(then, now);

      if (diffTime <= 0) {
        setTimeLeft({
          years: '00',
          months: '00',
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        });
        return;
      }

      const duration = intervalToDuration({ start: now, end: then });

      // Ensure all values exist with fallbacks to avoid undefined
      const years = String(duration.years || 0).padStart(2, '0');
      const months = String(duration.months || 0).padStart(2, '0');
      const days = String(duration.days || 0).padStart(2, '0');
      const hours = String(duration.hours || 0).padStart(2, '0');
      const minutes = String(duration.minutes || 0).padStart(2, '0');
      const seconds = String(duration.seconds || 0).padStart(2, '0');

      const result = {
        years,
        months,
        days,
        hours,
        minutes,
        seconds,
      };

      setTimeLeft(result);
    } catch (error) {
      console.error('Error in countdown:', error);
      setTimeLeft({
        years: '00',
        months: '00',
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      });
    }
  }, [endTime]);

  useEffect(() => {
    let interval = null;

    if (endTime) {
      updateCountdown();

      interval = setInterval(updateCountdown, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [endTime, updateCountdown]);

  return [timeLeft, setEndTime];
};

export default useCountdown;
